import { CounterBadgeStyles, CounterBadgeTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { CounterBadge } from "./counter-badge.js";
/**
 * The Fabric Counter Badge component.
 *
 * @public
 */
export const definition = CounterBadge.compose({
    name: `${DesignSystem.prefix}-counter-badge`,
    template: CounterBadgeTemplate,
    styles: CounterBadgeStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=counter-badge.definition.js.map